import { Injectable } from '@angular/core';
import { Router, Route, ActivatedRouteSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { getUserRoles } from '../core/functions';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    public afAuth: AngularFireAuth,
    public router: Router
  ) { }

  /** Guarda de ruta hija (dentro de un módulo ya cargado) que solo comprueba permisos, no autenticación. */
  canActivate(route: ActivatedRouteSnapshot)
    : Observable<boolean | UrlTree> {
    return this.afAuth.idTokenResult.pipe(
      map(userData => {
        if (userData == null) {
          return this.router.createUrlTree(['/auth']);
        }
        if (route.data?.permissions != null) {
          let roles = getUserRoles(userData.claims);
          return this.checkUserRoles(roles, route);
        }
        return true;
      })
    );
  }

  canLoad(route: Route, segments: UrlSegment[])
    : boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.afAuth.idTokenResult.pipe(
      map(userData => {
        if (userData == null) {
          if (route.path == 'auth' && segments[0].path == 'auth')
            return true;
          const navigationExtras = this.getNavigationExtras(segments);
          return this.router.createUrlTree(['/auth'], navigationExtras || undefined);
        }

        if (route.data?.permissions != null) {
          let roles = getUserRoles(userData.claims);
          return this.checkUserRoles(roles, route)
        }

        if (!segments.length) {
          if (route.data?.redirectTo)
            return this.router.createUrlTree([route.data.redirectTo]);
          return true;
        } else {
          if (route.path == segments[0].path && route.data?.redirectTo)
            return this.router.createUrlTree([route.data.redirectTo]);
          return true;
        }
      })
    );
  }

  private getNavigationExtras(segments: UrlSegment[]) {
    const urls = ["requests", "my-requests"]
    const partialUrl: string = segments.map(segment => segment.path).join('/');
    const navigationExtras = urls.includes(partialUrl) ?
      { queryParams: { x: partialUrl } } : null;
    return navigationExtras;
  }
  private checkUserRoles(roles, route: { data?: any }): boolean | UrlTree {
    let isOkRoles = false;
    let targetRoles = route.data.permissions.only as Array<string>;

    if (roles && targetRoles) {
      // Se guarda la lista de roles a comprobar en un array para facilitar su manejo
      let rolesArray = Array.isArray(targetRoles) ? targetRoles : [targetRoles];
      isOkRoles = roles.some(x => rolesArray.includes(x));
    }

    if (isOkRoles) {
      return true;
    }
    else {
      const redirectTo = route.data.permissions.redirectTo || '/access';
      return this.router.createUrlTree([redirectTo]);
    }
  }
}
